import { number, object } from 'yup';

const budgetPlannerValidation = (errorMessages) =>
  object().shape({
    adults: number()
      .required(errorMessages.required)
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .default(2),
    children: number()
      .required(errorMessages.required)
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .default(0),
    netIncome: number()
      .required(errorMessages.required)
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .max(999999999, errorMessages.max)
      .default(undefined),
    equity: number()
      .required(errorMessages.required)
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .max(999999999, errorMessages.max)
      .default(undefined),
    cars: number()
      .required(errorMessages.required)
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .default(1),
    motorcycles: number()
      .required(errorMessages.required)
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .default(0),
    repayment: number()
      .required(errorMessages.required)
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .max(999999999, errorMessages.max)
      .default(undefined),
    otherCapital: number()
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .max(999999999, errorMessages.max)
      .default(undefined),
    otherIncome: number()
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .max(999999999, errorMessages.max)
      .default(undefined),
    otherExpenses: number()
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .max(999999999, errorMessages.max)
      .default(undefined),
    monthlyRate: number().required().default(undefined), // computed
    buyingPrice: number().required().default(undefined), // computed
  });

export default budgetPlannerValidation;
